<div class="card product-card p-3 {{ isSelected() ? 'border-success bg-success-subtle' : '' }}">
  <div class="d-flex align-items-center gap-2">
    <h4 class="mb-0 lh-base">{{ model()?.modelName }}</h4>
    <span class="ms-auto d-flex align-items-center gap-2">
      <button
        class="px-2 btn btn-primary rounded-3 btn-sm d-flex align-items-center gap-2 btn-h35"
        (click)="addConfig.emit(); $event.stopPropagation()"
      >
        <i class="bi bi-plus lh-1"></i> <span>Add</span>
      </button>
    </span>
  </div>
  <div class="d-flex flex-wrap gap-3 fs-14 mt-2">
    <span><span class="text-muted">Bedrooms:</span> {{ model()?.bedrooms ?? '—' }}</span>
    <span><span class="text-muted">Stories:</span> {{ model()?.stories ?? '—' }}</span>
  </div>
  <div class="fs-14 mt-2"><span class="text-muted">Architectural Style:</span> {{ model()?.style ?? '—' }}</div>
</div>
